import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// --- Components ---
import { PagesComponent } from './pages.component';

// --- Guards ---
import { AuthGuard } from '@guards/auth.guard';
import { CustomerGuard } from '@guards/customer.guard';
import { GuestGuard } from '@guards/guest.guard';
import { VisitorGuard } from '@guards/visitor.guard';

const routes: Routes = [
	{
		path: '',
		component: PagesComponent,
		children: [
			{
				path: '',
				pathMatch: 'full',
				canActivate: [GuestGuard],
				loadChildren: () =>
					import('./home/home.module').then(m => m.HomeModule),
			},
			{
				path: 'new-customer',
				pathMatch: 'full',
				canActivate: [VisitorGuard],
				loadChildren: () =>
					import('./new-customer/new-customer.module').then(
						m => m.NewCustomerModule
					),
			},
			{
				path: 'access-requests',
				pathMatch: 'full',
				canActivate: [AuthGuard],
				loadChildren: () =>
					import('./access-requests/access-requests.module').then(
						m => m.AccessRequestsModule
					),
			},
			{
				path: 'product',
				loadChildren: () =>
					import('./product/product.module').then(m => m.ProductModule),
			},
			{
				path: 'account',
				canActivate: [AuthGuard],
				loadChildren: () =>
					import('./account/account.module').then(m => m.AccountModule),
			},
			{
				path: 'client-area',
				canActivate: [CustomerGuard],
				loadChildren: () =>
					import('./client-area/client-area.module').then(
						m => m.ClientAreaModule
					),
			},
			{
				path: 'preferences',
				canActivate: [AuthGuard],
				loadChildren: () =>
					import('./preferences/preferences.module').then(
						m => m.PreferencesModule
					),
			},
			{
				path: 'dashboard',
				canActivate: [AuthGuard],
				loadChildren: () =>
					import('./dashboard/dashboard.module').then(m => m.DashboardModule),
			},
			{
				path: 'integrations',
				canActivate: [AuthGuard],
				loadChildren: () =>
					import('./integrations/integrations.module').then(
						m => m.IntegrationsModule
					),
			},
		],
	},
	{
		path: 'auth',
		data: { animation: 'auth' },
		loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
	},
	{
		path: 'orders/:idOrder/print',
		canActivate: [AuthGuard],
		loadChildren: () =>
			import('./account/orders/order/print/print.module').then(
				m => m.PrintOrderModule
			),
	},
	{
		path: '**',
		data: { animation: 'not-found' },
		loadChildren: () =>
			import('./not-found/not-found.module').then(m => m.NotFoundModule),
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class PagesRoutingModule {}
